// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { Page } from "../flow/types";

export default function(
  state: Page = initialState.page,
  action: any
) {
    switch (action.type) { 
        case ActionTypes.GET_PAGE + ActionTypes.FULFILLED:
            const data = action.payload.data;
    if (data) {
        return { id: data.id, name: data.name, content: data.content, contentType: data.contentType, notFound: false };
          } else {
              return { notFound: true };
          }
    default:
      return state;
  }
}
